import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-logn_arrow",
  "use": "icon-logn_arrow-usage",
  "viewBox": "0 0 16 55",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 55\" id=\"icon-logn_arrow\"><path fill=\"#fff\" d=\"M15.744 46.788l-7.872 7.794L0 46.788l1.448-1.433 5.4 5.347V.054h2.048v50.648l5.4-5.347z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol